import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import get from 'lodash/get';

dayjs.extend(utc);

const CSV_UNSAFE_VALUE_PATTERN = /[",\r\n]/;
const CSV_FORMULA_LEAD_PATTERN = /^[=+\-@\t\r]/;

export type CsvColumn = { header: string; path: string };

const toCsvCell = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }

  const rawValue = Array.isArray(value) ? value.join(';') : String(value);
  const safeValue = CSV_FORMULA_LEAD_PATTERN.test(rawValue) && Number.isNaN(Number(rawValue)) ? `'${rawValue}` : rawValue;
  if (!CSV_UNSAFE_VALUE_PATTERN.test(safeValue)) {
    return safeValue;
  }

  return `"${safeValue.replace(/"/g, '""')}"`;
};

export const toCsv = (rows: unknown[], columns: CsvColumn[]): string => {
  const header = columns.map((column) => column.header).join(',');
  const body = rows.map((row) => columns.map(({ path }) => toCsvCell(get(row as object, path))).join(',')).join('\r\n');

  return `${header}\r\n${body}`;
};

export const selectCsvColumns = (columns: CsvColumn[], requested?: string | string[] | null): CsvColumn[] => {
  const keys = (Array.isArray(requested) ? requested : String(requested ?? '').split(',')).map((key) => key.trim()).filter(Boolean);
  if (!keys.length) {
    return columns;
  }
  const requestedSet = new Set(keys);
  return columns.filter((column) => requestedSet.has(column.path));
};

export const getDatedCsvFilename = (reportName: string): string => `${reportName}_${dayjs.utc().format('YYYY-MM-DD[T]HH-mm-ss[Z]')}.csv`;

const sanitizeFileNamePart = (value: unknown): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const buildSafeFileName = (...parts: unknown[]): string => parts.map(sanitizeFileNamePart).filter(Boolean).join('-');
